import { TableQuery } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { PRIMARY_DUMPSTER_DISTINGUISHED_ID, ARCHIVE_DUMPSTER_DISTINGUISHED_ID } from 'owa-folders';

/**
 * Returns a flag indicating whether the table is the dumpster table
 * @param tableQuery - the table query
 * @return whether the table is the dumpster table
 */
export default function isDumpsterTable(tableQuery: TableQuery): boolean {
    return (
        tableQuery.folderId === folderNameToId(ARCHIVE_DUMPSTER_DISTINGUISHED_ID) ||
        tableQuery.folderId === folderNameToId(PRIMARY_DUMPSTER_DISTINGUISHED_ID)
    );
}
